<template>
  <section class="tableWrap">
    <div class="dashWrap">
      <div class="dashRow">
        <h2 class="tit">기준 정보</h2>
        <div class="dashBx">
          <div class="formInfo">
            <v-form ref="formPresent">
              <dl class="infoCont">
                <dt class="formInfoTxt small">제목 <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                <dd class="formInfoArea">
                  <v-col class="mgr">
                    <v-text-field v-model="present.title" :rules="[rules.required]" label="" dense flat clearable/>
                  </v-col>
                </dd>
              </dl>
              <dl class="infoCont">
                <dt class="formInfoTxt small">사용여부  <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                <dd class="formInfoArea">
                  <v-col class="mgr">
                    <v-switch
                        v-model="present.activated"
                        flat
                        color="primary"
                        :label="present.activated ? '사용' : '사용안함'"
                    ></v-switch>
                  </v-col>
                </dd>
              </dl>
              <dl class="infoCont">
                <dt class="formInfoTxt small">상태  <i class="fa fa-asterisk" aria-hidden="true"/></dt>
                <dd class="formInfoArea">
                  <v-col class="mgr">
                    <v-radio-group v-model="present.state" row :rules="[rules.required]">
                      <v-radio
                          v-for="s in stateList"
                          :key="s.value"
                          :label="`${s.text}`"
                          :value="s.value"
                      ></v-radio>
                    </v-radio-group>
<!--                    -->
<!--                    <v-select :items="stateList" item-value="value" item-text="text" v-model="present.state"-->
<!--                              dense-->
<!--                              clearable-->
<!--                              flat-->
<!--                              outlined-->
<!--                              :rules="[rules.required]"-->
<!--                              label="상태"/>-->
                  </v-col>
                </dd>
              </dl>
              <dl class="infoCont">
                <dt class="formInfoTxt small">기준일(기념일)</dt>
                <dd class="formInfoArea">
                  <v-col class="mgr">
                    <v-menu
                        v-model="presentDateCal"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="present.presentDate"
                            label="기준일(기념일)"
                            prepend-icon="mdi-calendar"
                            readonly
                            clearable
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                        <!--                :rules="[rules.required]"-->
                      </template>
                      <v-date-picker
                          v-model="present.presentDate"
                          @input="presentDateCal = false"
                          locale="ko"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </dd>
              </dl>
              <dl class="infoCont">
                <dt class="formInfoTxt small">접수기간</dt>
                <dd class="formInfoArea" style="height: 89px">
                  <v-col class="mgr">
                    <date-range-component
                        v-on:event="result => receiptPeriod = result"
                        label="접수 시작일 ~ 종료일"
                        :value="receiptPeriod"
                        :outline="false"
                    />
                    <!--              :rules="[rules.required, rules.length20]"-->

                  </v-col>
                </dd>
              </dl>

              <dl class="infoCont">
                <dt class="formInfoTxt small">내용</dt>
                <dd>
                  <v-col class="mgr" sm="12">
                    <editor-quill :val="present.contents" ref="contents"/>
                  </v-col>
                </dd>
              </dl>
            </v-form>
          </div>

          <div class="btnStyleBx">
            <div class="btnCommon justify-center">
              <v-btn class="vBtn" color="#fafafa" @click="goList">
                <v-icon class="mr-2">mdi mdi-format-list-bulleted</v-icon>
                목록
              </v-btn>
<!--              <v-btn class="vBtn" color="#1991eb" dark @click="save">-->
              <v-btn class="vBtn" color="success" dark @click="save">
                <v-icon class="mr-2">mdi mdi-content-save</v-icon>
                저장
              </v-btn>
            </div>
          </div>

        </div>
      </div>

      <div class="dashRow">
        <h2 class="tit arrowLink d-flex align-center justify-space-between">
          <span>제품 설정</span>
        </h2>
        <div class="dashBx justify-space-around">
          <product-component :present-id="presentId" />
        </div>
      </div>
    </div>

  </section>
</template>

<script>

import presentApi from "@/api/PresentApi";
import EditorQuill from "@/views/component/EditorQuillComponent";
import DateRageComponent from "@/views/component/DateRageComponent";
import ProductComponent from "@/views/present/components/Product"

export default {
  name: "Basic",
  props: {
    presentId: String
  },
  components: {
    EditorQuill,
    'date-range-component': DateRageComponent,
    ProductComponent
  },
  data: () => ({
    present: {
      activated: true
    },
    stateList: [
      {
        value: 'STATE_END',
        text: '마감'
      },
      {
        value: 'STATE_RECEIPT',
        text: '접수중'
      },
      {
        value: 'STATE_READY',
        text: '접수대기'
      },
      {
        value: 'STATE_CANCEL',
        text: '취소'
      },
    ],
    receiptPeriod: [],
    presentDateCal: false,
    rules: {
      required: value => !!value || '필수 입력 항목입니다..',
      maxNumber: value => value && value < 2560 && value > 10 || '허용되지 않는 범위입니다.',
      length20: value => value && value.length > 20 || '필수 입력 항목입니다.',
    },
    isModify: false
  }),
  methods: {
    async save() {
      if(!await this.$refs.formPresent.validate())
        return;

      this.present.startDt = this.receiptPeriod?.[0]??null;
      this.present.endDt = this.receiptPeriod?.[1]??null;
      this.present.contents = this.$refs.contents.getValue();

      presentApi.save(this.present).then(data => {
        if (data) {
          if (this.present.presentId) {
            alert("수정되었습니다.");
          } else {
            alert("등록되었습니다.");
          }

          // data.presentId
          this.goList();
        } else {
          alert("Error");
        }
      });
    },
    goList() {
      this.$router.push({path: `/present`})
    },
  },
  created() {
    if (this.presentId) {
      presentApi.get(this.presentId).then(data => {
        this.present = data;
        this.receiptPeriod = [this.present.startDt, this.present.endDt].filter(d => d !== null);
        this.isModify = true;
      });
    }
  }
}
</script>


<style lang="scss" scoped>
@import '../../../assets/style/layout/variables';

.dashWrap {
  display: flex;
  flex-flow: row wrap;
}

.dashRow:first-child {
  flex: 0 1 49%;

  &:first-child {
    margin-right: 1%;
  }
}
.dashRow:nth-child(2) {
  flex: 0 1 50%;

}

.tit {
  margin-top: 30px;
  margin-left: 5px;
  margin-bottom: 10px;
  font-size: 18px;
}

.dashBx {
  padding: 20px;
  border: 1px solid #e9e9e9;

  .state {
    padding-top: 37px;
    padding-bottom: 37px;
    cursor: pointer;
    color: #666;

    dt {
      display: flex;
      justify-content: center;
      align-items: baseline;
      margin-bottom: 20px;

      em {
        margin-right: 5px;
        font-size: 50px;
        font-weight: bold;
        color: #333;
      }
    }

    dd {
      font-weight: 500;
    }
  }

  .deposit {
    display: flex;
    padding: 0;

    li {
      display: flex;
      justify-content: space-between;
      flex: 0 0 38%;

      &:nth-child(3) {
        flex: 0 0 24%;
      }

      .depositTit {
        width: 100px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #ccc;
        border-radius: 25px;
        background: #f6f6f6;
        font-size: 13px;
        font-weight: 600;
        color: #555;
        text-align: center;
      }

      .depositNum {
        display: flex;
        padding-top: 50px;
        padding-right: 30px;

        p {
          margin-right: 50px;

          em {
            font-size: 40px;
            font-weight: bold;
          }
        }
      }
    }
  }

}

.h3Title {
  @include h3-title;
}
.tabContent{
  .formInfo {
    @include form-info;
  }
  .formInfoArea{
    &.align-normal{
      align-items: normal !important;
    };
  }
  .list{
    display: flex;
    width: 100% !important;
    img{
      width: 100%;
      height: auto;
    }
  }
  .wh300{
    width: 300px;
    padding: 0;
  }
}
</style>